import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { priceMonitoringConfig } from "@/lib/datasetRegistry"

// Thin config module — the whole page is the parameterized <DatasetUploadsPage>
// driven by `priceMonitoringConfig` (app/frontend/lib/datasetRegistry.ts). The
// controller renders this via inertia page name "admin/price_monitoring/Uploads".
export default function AdminPriceMonitoringUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return <DatasetUploadsPage config={priceMonitoringConfig} {...props} />
}
